export default (name: string): string => {
  const prependedName = name.startsWith('REACT_APP') ? name : `REACT_APP_${name}`;
  const envVar = process.env[prependedName];
  if (!envVar) throw new Error(`Environment Variable is not defined (${name})`);
  return envVar;
};
